<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7rgvxt/tc-custom/9781504069908.jpg?1727406742890" alt="This image is the cover for the book Lily's Little Flower Shop"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lily's Little Flower Shop
      </h1>
      <p class="bookDescription body article font2">
        <p><b>“Lighthearted but with pleasing depth, told with warmth and humor . . . a bloomin’ good story” from the author of <i>My Big Greek Holiday</i> (<i>Book’d Out</i>).</b><br/><br/><i>Can life ever be a bed of roses?</i><br/><br/> When Lily misses out on a well-deserved promotion the day her boyfriend is offered a job overseas, she faces a choice: should she embrace an expat life, or follow her childhood dream and become a florist?<br/><br/> Deciding to follow her heart, she moves to the coast to start over. But fitting into the tight-knit community proves harder than she expected.<br/><br/> As she navigates new friendships, financial worries, and the pull of returning to her city life, she learns how flowers can bring her the happiness she’s been looking for.<br/><br/> And when romance appears on the horizon, Lily realizes she can’t commit until she reconciles her mistakes.<br/><br/><b>Can she overcome her past and learn the true meaning of love?<br/><br/> Discover the perfect feel-good read for all seasons.</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lisa Darcy
      </h2>
      
      <p class="authorDescription body article">I studied as a journalist at Queensland University a hundred years ago.  With three children under five, I decided to pursue my passion for writing fiction, specifically stories about women in their thirties and forties, navigating friendships, careers, romance, and ultimately triumphing over adversity.   To date, I have six published novels, five with Allen & Unwin. They are Lucy Springer Gets Even, What Kate Did Next, Claudia’s Big Break, Stella Makes Good, and It Started With A Kiss.I self-published The Callahan Split.  My seventh manuscript, Lily’s Little Flower Shop is more strongly romance-focussed than my previous stories. It’s a fish-out-of-water, coastal romance.   I teach Creative Writing at the Australian Writers’ Centre in Sydney, and have a wide network of authors, readers and presenters that I can tap into.   I am a confident and engaging public speaker and have presented workshops and been on panels at the RWA conferences, GenreCon, Sydney Writers’ Festival, and many regional writers’ festivals.  I have also spoken at, and presented, workshops at numerous libraries throughout Australia.   Website: www.lisaheidke.com  Facebook: https://www.facebook.com/lisa.heidke.author/</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?072eb681